module.exports = __webpack_public_path__ + "static/media/online_g.7ff6999e.svg";